module.exports = __webpack_public_path__ + "static/media/saurabh_jog.3f13ab19.jpg";